import React from 'react';
import { useRequest } from 'hooks';
import { useParams } from 'react-router-dom';

import Category from 'components/Ui/Category';
import { Form, Input, Datepicker, Button } from 'components/Misc/Form';

import { useGradeCertificateStore } from 'store/grade/useGradeCertificateStore';

const Settings = ({ studentId, certificate }) => {
	const { id } = useParams();

	const [[createProgress], requestCreate] = useRequest('post', 'certificates');
	const [[updateProgress], requestUpdate] = useRequest('put', `certificates/${certificate.id}`);

	// Use grade certificate store
	const [onChangeCertificate, onUpdateCertificate] = useGradeCertificateStore(state => [
		state.onChangeCertificate,
		state.onUpdateCertificate
	]);

	const onChange = (change) => onChangeCertificate(studentId, change);

	const onSubmit = async (event) => {
		event.preventDefault();

		const [success, error] = certificate.id
			? await requestUpdate(certificate, {
				type: 'certificate'
			})
			: await requestCreate({
				...certificate,
				gradeId: id,
				studentId
			});

		if (success) onUpdateCertificate(success.certificate);

		if (error) console.warn(error);
	};

	return (
		<Category title="Iestatījumi" hide>
			<Form onSubmit={onSubmit} className="grid grid-cols-2 gap-4">
				<Input
					value={certificate.series}
					onChange={onChange}
					name="series"
					label="Sertifikāta sērija"
				/>

				<Input
					value={certificate.number}
					onChange={onChange}
					name="number"
					label="Sertifikāta numurs"
				/>

				<Datepicker
					asInput
					value={certificate.issueDate}
					onChange={onChange}
					name="issueDate"
					label="Izsniegšanas datums"
				/>

				<div className="flex flex-col">
					<div className="mb-1 text-sm font-bold text-neutral-800 dark:text-white transition-colors">
						Direktors
					</div>

					<div className="leading-8">
						E. Grīnis
					</div>
				</div>

				<Input
					value={certificate.teacherOneName}
					onChange={onChange}
					name="teacherOneName"
					label="Pedagogs (1)"
				/>

				<Input
					value={certificate.teacherTwoName}
					onChange={onChange}
					name="teacherTwoName"
					label="Pedagogs (2)"
				/>

				<div className="col-span-2 flex justify-end items-end">
					<Button
						submit
						icon="done"
						value="Saglabāt"
						theme="success"
						progress={createProgress || updateProgress}
					/>
				</div>
			</Form>
		</Category>
	);
};

export default Settings;